import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlanProgressorMonitorComponent } from './plan-progressor-monitor/plan-progressor-monitor.component';
import { ObjectivesCatalogComponent } from './objectives-catalog/objectives-catalog.component';
import { UserObjectivesListComponent } from './user-objectives-list/user-objectives-list.component';
import { GoalsListComponent } from './goals-list/goals-list.component';
import { UnassignedReferralsComponent } from './unassigned-referrals/unassigned-referrals.component';

const routes: Routes = [
  {
    path: '',
    component: PlanProgressorMonitorComponent,
  },
  {
    path: 'list',
    component: GoalsListComponent,
  },
  {
    path: 'referrals',
    component: UnassignedReferralsComponent,
  },
  {
    path: 'objectives',
    component: ObjectivesCatalogComponent,
  },
  {
    path: 'user-objectives',
    component: UserObjectivesListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class GoalsRoutingModule {}
